export const MIN_VIRTUALIZED_POPUP_WIDTH = 170;

export const MAX_CONTROL_WIDTH_WITH_ANIMATION = 500;
